'use client'
import { useState } from 'react'
import { copyTextToClipboard } from 'src/_helpers/copyToClipboard'
import Typography from './Typography'

export default function TypographyExample({ variant, label, text, additionalClassName = '' }) {
  const [copied, setCopied] = useState(false)

  const getComponentCode = () => {
    const colorAttr = additionalClassName.includes('buttons--bold') ? ' color="text-basic-white"' : ''
    const classNameAttr = additionalClassName ? ` className="${additionalClassName}"` : ''
    return `<Typography variant="${variant}"${colorAttr}${classNameAttr}>${text}</Typography>`
  }

  const handleCopy = async () => {
    const success = await copyTextToClipboard(getComponentCode())
    if (!success) return

    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="bg-basic-gray8 rounded-lg p-16 space-y-8">
      <div className="flex items-center justify-between">
        <Typography variant="body4" color="text-basic-gray5">
          {label}
        </Typography>
        <button
          onClick={handleCopy}
          className="px-4 py-1 text-xs bg-basic-gray6 hover:bg-basic-gray5 text-basic-black rounded transition-colors"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>

      <Typography variant={variant} className={additionalClassName}>
        {text}
      </Typography>

      <div className="bg-basic-white rounded p-4">
        <code className="text-sm text-basic-gray3 block break-all">{getComponentCode()}</code>
      </div>
    </div>
  )
}
